module.exports = __webpack_public_path__ + "img/prf.c58d0ea9.png";